export default class MovePostCtrl {
  constructor(Authentication, NewsfeedCollection, $uibModalInstance, /* resolves */ post) {
    'ngInject';

    Object.assign(this, { Authentication, NewsfeedCollection, $uibModalInstance, post });
  }

  get pages() {
    return this.NewsfeedCollection.pages.filter((p) =>
      this.NewsfeedCollection.canPostArticle(p, this.Authentication.user)
    );
  }

  async submit() {
    if (!this.selectedPage) {
      throw 'no page selected';
    }

    const { data: updatedPost } = await this.Authentication.sendRequest({
      method: 'post',
      path: `channels/${this.post.channel.id}/articles/${this.post.id}/move`,
      payload: {
        channelId: this.selectedPage.id,
      },
    });

    this.NewsfeedCollection.editArticle(updatedPost);
    this.$uibModalInstance.close(updatedPost);
  }

  get otherWritablePages() {
    return this.pages.filter((p) => p.writable && p.id !== this.post.channel.id);
  }
}
